export const APP_DETAILS = "APP_DETAILS";
export const BANK_DETAILS = "BANK_DETAILS";
export const BANNERS = "BANNERS";
export const SHOW_LEFT_SIDEBAR = "SHOW_LEFT_SIDEBAR";
export const LANGUAGE = "LANGUAGE";
export const THEME = "THEME";
